// extracted by mini-css-extract-plugin
export default {"surface":"SwitchTabViewContainer_surface__u5Etz"};